<template>
  <v-col cols="12">
    <template v-if="loading">
      <v-progress-circular indeterminate color="accent" size="16" width="4"/>
    </template>
    <template v-else>
      <template v-if="displayAdditionalFields">
        <c-autocomplete v-model="withinArbLimitObj"
                        :label="$t('filing.customFieldsMap.withinArbLimit')"
                        :items="arbLimitValues"
                        key="fobo"
                        item-text="label"
                        item-value="value"
                        return-object hide-details="auto"
                        aria-describedby="433ae064-5140-4e0b-a22a-1b83aa7dfa2c"
                        @input="emitValues">
          <template #selection="{ item }">
            <div class="portal-dropdown-chip">
              {{ item.label }}
            </div>
          </template>
        </c-autocomplete>
        <field-description id="433ae064-5140-4e0b-a22a-1b83aa7dfa2c"
                           message-key="filing.customFieldsMap.withinArbLimit.description"/>
        <c-checkbox v-model="mdjAppeal"
                    @change="emitValues"
                    :label="$t('filing.customFieldsMap.mdjAppeal')"
                    class="mt-0"
                    hide-details="auto"
                    aria-describedby="3f575f7e-e2c4-45ad-89db-c296abf7dd1a"/>
        <field-description id="3f575f7e-e2c4-45ad-89db-c296abf7dd1a"
                           message-key="filing.customFieldsMap.mdjAppeal.description"/>
        <c-checkbox v-model="classActionSuit"
                    @change="emitValues"
                    :label="$t('filing.customFieldsMap.classActionSuit')"
                    class="mt-0"
                    hide-details="auto"
                    aria-describedby="717a767f-34e3-410f-9143-438e7eecb952"/>
        <field-description id="717a767f-34e3-410f-9143-438e7eecb952"
                           message-key="filing.customFieldsMap.classActionSuit.description"/>
        <c-checkbox v-model="proSe"
                    @change="emitValues"
                    :label="$t('filing.customFieldsMap.proSe')"
                    class="mt-0"
                    hide-details="auto"
                    aria-describedby="0f3566a1-44c1-4034-86f0-8280cbeb0a01"/>
        <field-description id="0f3566a1-44c1-4034-86f0-8280cbeb0a01"
                           message-key="filing.customFieldsMap.proSe.description"/>
        <c-autocomplete v-model="juryTrialDemandedObj"
                        :label="$t('filing.customFieldsMap.juryTrialDemanded')"
                        :items="juryTrialDemandedValues"
                        key="jtdv"
                        item-text="label"
                        item-value="value"
                        return-object hide-details="auto"
                        aria-describedby="03349525-033f-4e31-8e9d-732ecea1b380"
                        @input="emitValues">
          <template #selection="{ item }">
            <div class="portal-dropdown-chip">
              {{ item.label }}
            </div>
          </template>
        </c-autocomplete>
        <field-description id="03349525-033f-4e31-8e9d-732ecea1b380"
                           message-key="filing.customFieldsMap.juryTrialDemanded.description"/>
      </template>
    </template>
  </v-col>
</template>
<script>
import FieldDescription from '@components/support/FieldDescription.vue';
import _ from 'lodash';
import axios from 'axios';
import { useFilingStore } from '@/stores/filingStore';

const filingStore = useFilingStore();
export default {
  components: { FieldDescription },
  props: {
    originalBean: {
      type: null // syntax to use when this can be any type
    }
  },
  data () {
    return {
      mdjAppeal: false,
      classActionSuit: false,
      proSe: false,
      withinArbLimitObj: null,
      // TODO it would really be better to get this from a service but we don't have these defined on the CMS side to call
      arbLimitValues: [{ label: 'Within Arbitration Limits', value: 1000364 }, { label: 'Outside of Arbitration Limits', value: 1000365 }],
      juryTrialDemandedObj: null,
      juryTrialDemandedValues: [{ label: 'Jury Trial Demanded', value: 1128189 }, { label: 'No Demand', value: 1128190 }],
      loading: true,
      caseTypeID: 0
    };
  },
  computed: {
    isNewCaseFiling () {
      return filingStore.isNewCaseFiling;
    },
    displayAdditionalFields () {
      return this.isNewCaseFiling &&
          this.caseTypeID === 1000000 // CASE_TYPE_CIVIL_APPEAL
          || this.caseTypeID === 1000001 // CASE_TYPE_CONTRACT
          || this.caseTypeID === 1000004 // CASE_TYPE_MASS_TORT
          || this.caseTypeID === 1000005 // CASE_TYPE_MISCELLANEOUS
          || this.caseTypeID === 1000007 // CASE_TYPE_PROFESSIONAL_LIABILITY_ACTION
          || this.caseTypeID === 1000008 // CASE_TYPE_REAL_PROPERTY
          || this.caseTypeID === 1000009; // CASE_TYPE_TORT
    }
  },
  created () {
    this.mdjAppeal = _.isNil(this.originalBean.filing.customFieldsMap)
      ? null : this.originalBean.filing.customFieldsMap.mdjAppeal;
    this.classActionSuit = _.isNil(this.originalBean.filing.customFieldsMap)
      ? null : this.originalBean.filing.customFieldsMap.classActionSuit;
    this.proSe = _.isNil(this.originalBean.filing.customFieldsMap)
      ? null : this.originalBean.filing.customFieldsMap.proSe;
    this.withinArbLimitObj = (_.isNil(this.originalBean.filing.customFieldsMap)
        || !_.isNumber(this.originalBean.filing.customFieldsMap.withinArbLimit))
      ? null : _.find(this.arbLimitValues, { 'value': this.originalBean.filing.customFieldsMap.withinArbLimit });
    this.juryTrialDemandedObj = (_.isNil(this.originalBean.filing.customFieldsMap)
        || !_.isNumber(this.originalBean.filing.customFieldsMap.juryTrialDemandedCode))
      ? null : _.find(this.juryTrialDemandedValues, { 'value': this.originalBean.filing.customFieldsMap.juryTrialDemandedCode });
    let promises = [];
    promises.push(this.loadCaseTypeID());
    Promise.all(promises)
      .finally(() => {
        this.loading = false;
      });
  },
  methods: {
    loadCaseTypeID () {
      return axios.get(this.$cove.getAPI({
        name: 'api.court.case.classification',
        params: {
          courtID: this.originalBean.filing.court.resourceID,
          caseClassID: this.originalBean.filing.courtCase.caseClassificationIdentifier
        }
      }))
        .then((response) => {
          this.caseTypeID = response.data.caseType.caseTypeID;
        });
    },
    emitValues () {
      this.$emit('filingCustomFieldsMap', {
        'mdjAppeal': this.mdjAppeal,
        'classActionSuit': this.classActionSuit,
        'proSe': this.proSe,
        'withinArbLimit': _.isNil(this.withinArbLimitObj) ? null : this.withinArbLimitObj.value,
        'withinArbLabel': _.isNil(this.withinArbLimitObj) ? null : this.withinArbLimitObj.label,
        'juryTrialDemandedCode': _.isNil(this.juryTrialDemandedObj) ? null : this.juryTrialDemandedObj.value,
        'juryTrialDemandedName': _.isNil(this.juryTrialDemandedObj) ? null : this.juryTrialDemandedObj.label
      });
    }
  }
};
</script>